/**
 * JS 运行时异常采集：window.onerror + 未捕获的 Promise rejection
 */
import { IGNORED_ERROR_PATTERNS, MONITOR_CONFIG } from '@/monitor/config';
import { readApiContext, reportUncaughtApiError } from '@/monitor/collectors/apiError';
import { track } from '@/monitor/core/aggregator';

/** 命中噪音规则的错误直接丢弃 */
const isNoise = (message: string): boolean => IGNORED_ERROR_PATTERNS.some((re) => re.test(message));

const trimStack = (stack?: string): string | undefined =>
  stack?.split('\n').slice(0, MONITOR_CONFIG.STACK_LINES).join('\n');

export const setupJsErrorCollector = (): void => {
  window.addEventListener('error', (event: ErrorEvent) => {
    /** 资源加载错误由 resource 采集器处理，这里只收脚本运行时错误 */
    if (event.target && event.target !== window) return;
    const message = event.message || String(event.error);
    if (isNoise(message)) return;
    track({
      type: 'js_error',
      level: 'error',
      title: 'JS 运行时异常',
      message,
      source: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : undefined,
      stack: trimStack(event.error?.stack),
      timestamp: Date.now(),
    });
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason: unknown = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    if (isNoise(message)) return;
    /** 未 catch 的接口错误改按「后端接口报错」上报，带出路径与参数（详见 apiError.ts） */
    const apiContext = readApiContext(reason);
    if (apiContext) {
      reportUncaughtApiError(apiContext, message, { 来源: '未捕获的 Promise' });
      return;
    }
    track({
      type: 'promise_error',
      level: 'error',
      title: '未捕获的 Promise 异常',
      message,
      stack: reason instanceof Error ? trimStack(reason.stack) : undefined,
      timestamp: Date.now(),
    });
  });
};
